import React, {useEffect, useRef} from 'react';
import './MenuDemoSetupIntro.css';
import SetupPlayersModal, {
  SETUP_PLAYER_MODAL_DURATION_PER_PLAYER,
  SETUP_PLAYER_MODAL_PLAYER_ANIMATION_DURATION_MS,
} from '../../Modals/SetupPlayersModal/SetupPlayersModal';

// Ширина и высота, под которые сверстана плашка представления игроков: в
// витрине места меньше, чем на весь экран, поэтому содержимое верстается в
// этом размере и целиком ужимается под фактическую область (см. scale ниже)
const INTRO_DESIGN_WIDTH = 640;
const INTRO_DESIGN_HEIGHT = 560;

// В матче плашка объявляет жеребьевку, а на витрине идет запись чужой партии:
// «жребий» там уже брошен без зрителя. Заодно сразу видно, что игра шла между
// живыми людьми, а не ботами
const REPLAY_TITLE = 'Реплей реального матча';

/**
 * Представление игроков на витрине главного меню: та же плашка «Жребий
 * брошен!», что показывается в начале настоящего матча (SetupPlayersModal), но
 * не на весь экран, а внутри области витрины.
 *
 * Матч начинается только после того, как анимация доиграла: MenuDemoGame
 * держит ReplayRunner/BotRunner не смонтированным, пока не придет onFinished.
 * Длительность считается той же формулой, что и задержка старта настоящего
 * матча в GameContent.
 */
function MenuDemoSetupIntro({playerCount, showcaseSize, isReplay, soundVolume, onFinished}) {
  const onFinishedRef = useRef(onFinished);
  useEffect(() => {
    onFinishedRef.current = onFinished;
  }, [onFinished]);

  useEffect(() => {
    if (!playerCount) {
      return;
    }
    const durationMs = playerCount * SETUP_PLAYER_MODAL_DURATION_PER_PLAYER
      + SETUP_PLAYER_MODAL_PLAYER_ANIMATION_DURATION_MS;
    const timer = setTimeout(() => onFinishedRef.current?.(), durationMs);
    return () => clearTimeout(timer);
  }, [playerCount]);

  // На узкой витрине содержимое не поместится в натуральную величину: верстаем
  // его в размере макета и ужимаем целиком, чтобы пропорции остались теми же,
  // что и в настоящем матче
  const scale = showcaseSize
    ? Math.min(
      1,
      showcaseSize.width / INTRO_DESIGN_WIDTH,
      showcaseSize.height / INTRO_DESIGN_HEIGHT
    )
    : 1;

  const canvasStyle = scale < 1
    ? {width: `${100 / scale}%`, height: `${100 / scale}%`, transform: `scale(${scale})`}
    : undefined;

  return (
    <div className={`menu-demo-setup-intro${showcaseSize ? ' menu-demo-setup-intro_compact' : ''}`}>
      <div className="menu-demo-setup-intro-canvas" style={canvasStyle}>
        <SetupPlayersModal
          title={isReplay ? REPLAY_TITLE : undefined}
          soundVolume={soundVolume}
        />
      </div>
    </div>
  );
}

export default MenuDemoSetupIntro;
